import { useState, MouseEvent, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import MoreVert from "@material-ui/icons/MoreVert";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { useTableActionStyles } from "./styles";
import { AttendanceLocalDepartment } from "../../../../../../../../../@types/attendance-local-department";
import { useAttendanceLocalDepartmentDelete } from "../../../../../../../../../services/api-tansquery/attendance-local/department/delete";
import DeleteConfirmationModal from "../../../../../../../../../Components/ConfirmDelete";
import { useMultiModal } from "../../../../../../../../../hooks/useMultiModal";
import Info from "@material-ui/icons/Info";

type DepartmentTableActionsProps = {
    id: AttendanceLocalDepartment["id"];
    item: AttendanceLocalDepartment;
};

export default function DepartmentTableActions({ id, item }: DepartmentTableActionsProps) {
    const { modals, toggleModal } = useMultiModal(["delete"]);
    const { pathname } = useLocation();
    const { classes } = useTableActionStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const mutation = useAttendanceLocalDepartmentDelete(id);

    function handleClick(event: MouseEvent<HTMLElement>) {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    async function handleDelete() {
        await mutation.mutateAsync();
    };

    useEffect(() => {
        if (mutation.isSuccess) {
            toggleModal("delete", false);
            handleClose();
        }
    }, [mutation.isSuccess, toggleModal, handleClose]);

    return (
        <>
            <IconButton onClick={handleClick}>
                <MoreVert />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
            >
                <MenuItem
                    component={Link}
                    onClick={handleClose}
                    className={classes.menuItem}
                    to={`${pathname}/setor/${id}`}
                >
                    <Info htmlColor="#706E7A" />
                    Informações
                </MenuItem>
                <MenuItem
                    component={Link}
                    className={classes.menuItem}
                    to={`${pathname}/setor/editar/${id}`}
                >
                    <Edit htmlColor="#706E7A" />
                    Editar
                </MenuItem>
                <MenuItem
                    onClick={() => toggleModal("delete", true)}
                    className={classes.menuItem}
                >
                    <Delete htmlColor="#706E7A" />
                    Excluir
                </MenuItem>
            </Menu>
            <DeleteConfirmationModal
                onClose={() => {
                    toggleModal("delete", false);
                    handleClose();
                }}
                onConfirm={handleDelete}
                open={modals.delete}
                loading={mutation.isLoading}
                title="Remover Setor"
                legend={[
                    "Você está prestes a remover este setor do sistema.",
                    "Tem certeza que deseja continuar?"
                ]}
            />
        </>
    );
}
